/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/promql/x-pack-esql/definition/operators/and.json`.

import type { PromqlOperatorDefinition } from '../../definition_types';

/**
 * Returns elements from the left vector that have matching label sets in the right vector. Values and metric name come from the left-hand side.
 *
 * @example
 * vector1 and vector2
 */
const definition: PromqlOperatorDefinition = {
  type: 'operator',
  operator: 'and',
  name: 'and',
  signatures: [
    {
      params: [
        {
          name: 'lhs',
          type: 'instant_vector',
          optional: false,
          description: 'Instant vector.',
        },
        {
          name: 'rhs',
          type: 'instant_vector',
          optional: false,
          description: 'Instant vector.',
        },
      ],
      variadic: false,
      returnType: 'instant_vector',
    },
  ],
  snapshotOnly: false,
};

export default definition;
